/**
 * Service Provider Service
 */
angular.module('elogbooksServices').service('serviceProviderService', function (apiClient, $q, lodash, modulesService, $translate, elbSettings) {
    this.create = createServiceProvider;
    this.update = updateServiceProvider;
    this.getFromPartnershipForMultiCheckbox = getFromPartnershipForMultiCheckbox;
    this.getPrimaryOperatives = getPrimaryOperatives;
    this.formatServiceProviderName = formatServiceProviderName;
    this.prosureStatusHeaders = prosureStatusHeaders;
    this.prosureGroupReorder = prosureGroupReorder;
    this.setProsureWarningMessage = setProsureWarningMessage;
    this.getProsureWarningMessage = getProsureWarningMessage;
    this.filterProsureSpList = filterProsureSpList;

    this.isProsureEnabled = elbSettings.getSetting('prosure_enabled').value;
    this.prosure360StatusOptions = [
        {
            title: $translate.instant('PROSURE_REQUIREMENTS_SUCCESS'),
            value: 0
        },
        {
            title: $translate.instant('PROSURE_REQUIREMENTS_EXPIRING'),
            value: 1
        },
        {
            title: $translate.instant('PROSURE_REQUIREMENTS_BELOW'),
            value: 2
        },
        {
            title: $translate.instant('PROSURE_SUSPENDED'),
            value: 3
        },
        {
            title: $translate.instant('VANTIFY_SUPPLY_CHAIN_NOT_LINKED'),
            value: 99
        }
    ];

    /**
     * Create a service provider
     */
    function createServiceProvider(sp, form) {

        var deferred = $q.defer();

        apiClient.create(sp.getLink('self'), form).then(function (isSuccess) {
            if (isSuccess) {
                return deferred.resolve();
            } else {
                return deferred.reject('Unable to create, please try later');
            }
        });

        return deferred.promise;
    }

    /**
     * Update a service provider
     */
    function updateServiceProvider(sp, form) {

        var deferred = $q.defer();

        apiClient.update(sp.getLink('self'), form).then(function (isSuccess) {
            if (isSuccess) {
                return deferred.resolve();
            } else {
                return deferred.reject('Unable to update, please try later');
            }
        });

        return deferred.promise;
    }

    /**
     *
     * @param {RequestData|string} siteResponse
     * @returns {Promise}
     */
    function getFromPartnershipForMultiCheckbox(siteResponse) {
        if (typeof siteResponse === 'string') {
            var deferred = $q.defer();

            apiClient.get(siteHref).then(
                function (siteResponse) {
                    getPartnerships(siteResponse).then(
                        function (response) {
                            deferred.resolve(response);
                        }
                    );
                }
            );

            return deferred.promise;
        }

        return getPartnerships(siteResponse);
    }

    function getPartnerships(siteResponse) {
        var deferred = $q.defer(),
            sitePartnerships = [];
        apiClient.get(site.getLink('partnerships')).then(
            function (response) {
                lodash.forEach(siteResponse.partnerships,
                    function (response) {
                        //multiple checkbox requires label for href
                        sitePartnerships.push({
                            name: response._links.serviceprovider.title,
                            label: response._links.serviceprovider.href,
                            value: response._links.serviceprovider.href
                        });
                    });

                deferred.resolve(sitePartnerships);
            }
        );

        return deferred.promise;
    }

    function getPrimaryOperatives(sp) {
        var primaryOperatives = [
            {
                type: 'job',
                operative: lodash.has(sp, '_links.primary-job-operative') ? sp._links['primary-job-operative'] : null,
                label: $translate.instant('PRIMARY_JOB_OPERATIVE'),
            },
            {
                type: 'escalation',
                operative: lodash.has(sp, '_links.primary-escalation-operative') ? sp._links['primary-escalation-operative'] : null,
                label: $translate.instant('PRIMARY_ESCALATION_OPERATIVE'),
            }
        ];

        if (modulesService.isEnabled('quotes')) {
            primaryOperatives.push({
                type: 'quote',
                operative: lodash.has(sp, '_links.primary-quote-operative') ? sp._links['primary-quote-operative'] : null,
                label: $translate.instant('PRIMARY_QUOTE_OPERATIVE'),
            });
            primaryOperatives.push({
                type: 'quoteReviewer',
                operative: lodash.has(sp, '_links.primary-quote-reviewer-operative') ? sp._links['primary-quote-reviewer-operative'] : null,
                label: $translate.instant('PRIMARY_QUOTE_REVIEWER_OPERATIVE'),
            });
        }

        primaryOperatives.push({
            type: 'healthsafety',
            operative: lodash.has(sp, '_links.primary-health-safety-operative') ? sp._links['primary-health-safety-operative'] : null,
            label: $translate.instant('PRIMARY_HEALTH_SAFETY_OPERATIVE'),
        });

        if (modulesService.getEnabled('audits_module_enabled')) {
            primaryOperatives.push({
                type: 'audit',
                operative: lodash.has(sp, '_links.primary-audit-operative') ? sp._links['primary-audit-operative'] : null,
                label: $translate.instant('PRIMARY_AUDIT_OPERATIVE'),
            });
        }

        if (modulesService.getEnabled('patrols_module_enabled')) {
            primaryOperatives.push({
                type: 'patrol',
                operative: lodash.has(sp, '_links.primary-patrol-operative') ? sp._links['primary-patrol-operative'] : null,
                label: $translate.instant('PRIMARY_PATROL_OPERATIVE'),
            });
        }

        if (modulesService.getEnabled('surveys_module_enabled')) {
            primaryOperatives.push({
                type: 'survey',
                operative: lodash.has(sp, '_links.primary-survey-operative') ? sp._links['primary-survey-operative'] : null,
                label: $translate.instant('PRIMARY_SURVEY_OPERATIVE'),
            });
        }

        return primaryOperatives;
    }

    /**
     * @returns value string
     */
    function formatServiceProviderName(serviceProvider) {
        if (!serviceProvider) {
            return;
        }

        var value = serviceProvider.name || serviceProvider.getLinkAttribute('serviceprovider', 'title');

        return value;
    }

    function prosureStatusHeaders(serviceProvider) {
        if (elbSettings.getSetting('prosure_enabled').value) {
            switch (serviceProvider.object.meetsProsureRequirements) {
                case 'PROSURE_REQUIREMENTS_SUCCESS':
                    serviceProvider.header = $translate.instant('VANTIFY_SUPPLY_CHAIN_SP_REQUIREMENTS_SUCCESS');
                    break;
                case 'PROSURE_REQUIREMENTS_EXPIRING':
                    serviceProvider.header = $translate.instant('VANTIFY_SUPPLY_CHAIN_SP_REQUIREMENTS_EXPIRING');
                    break;
                case 'PROSURE_REQUIREMENTS_BELOW':
                    serviceProvider.header = $translate.instant('VANTIFY_SUPPLY_CHAIN_SP_REQUIREMENTS_BELOW');
                    break;
                case 'PROSURE_SUSPENDED':
                    serviceProvider.header = $translate.instant('VANTIFY_SUPPLY_CHAIN_SP_SUSPENDED');
                    break;
                default:
                    serviceProvider.header = $translate.instant('NO_VANTIFY_SUPPLY_CHAIN_SP');
            }
        }

        return serviceProvider;
    }

    function prosureGroupReorder(items) {
        var groups = [];

        if (elbSettings.getSetting('prosure_enabled').value) {
            angular.forEach(items, function (item) {
                switch (item.name) {
                    case $translate.instant('VANTIFY_SUPPLY_CHAIN_SP_REQUIREMENTS_SUCCESS'):
                        groups[0] = item;
                        break;
                    case $translate.instant('VANTIFY_SUPPLY_CHAIN_SP_REQUIREMENTS_EXPIRING'):
                        groups[1] = item;
                        break;
                    case $translate.instant('VANTIFY_SUPPLY_CHAIN_SP_REQUIREMENTS_BELOW'):
                        groups[2] = item;
                        break;
                    case $translate.instant('VANTIFY_SUPPLY_CHAIN_SP_SUSPENDED'):
                        groups[3] = item;
                        break;
                    case $translate.instant('NO_VANTIFY_SUPPLY_CHAIN_SP'):
                        groups[4] = item;
                        break;
                }
            });

            groups = groups.filter(function (group) {
                return group !== null;
            });
        }

        if (groups.length > 0) {
            return groups;
        } else {
            return items;
        }
    }

    function setProsureWarningMessage(serviceProvider) {
        var warningMessage = null;

        switch (serviceProvider.object.meetsProsureRequirements) {
            case 'PROSURE_REQUIREMENTS_SUCCESS':
                break;
            case 'PROSURE_REQUIREMENTS_EXPIRING':
                warningMessage = $translate.instant('VANTIFY_SUPPLY_CHAIN_REQUIREMENTS_EXPIRING_WARNING');
                break;
            case 'PROSURE_REQUIREMENTS_BELOW':
                warningMessage = $translate.instant('VANTIFY_SUPPLY_CHAIN_REQUIREMENTS_BELOW_WARNING');
                break;
            case 'PROSURE_SUSPENDED':
                warningMessage = $translate.instant('VANTIFY_SUPPLY_CHAIN_SUSPENDED_WARNING');
                break;
            default:
                warningMessage = $translate.instant('NOT_IN_MY_SUPPLY_CHAIN_WARNING');
                break;
        }

        return warningMessage;
    }

    function getProsureWarningMessage(serviceProviders) {
        if (!serviceProviders || serviceProviders.length === 0) {
            return {message: null, color: null};
        }

        if (serviceProviders.length === 1) {
            const message = setProsureWarningMessage({object: serviceProviders[0]});
            const color = serviceProviders[0].meetsProsureRequirements === 'PROSURE_SUSPENDED' ? 'danger' : 'warning';

            return {message, color};
        }

        const allMeetsRequirements = serviceProviders.every(sp => sp.meetsProsureRequirements === 'PROSURE_REQUIREMENTS_SUCCESS');

        if (allMeetsRequirements) {
            return {message: null, color: null};
        } else {
            let highestSeverity = getSeverityWarning(serviceProviders);
            let message = null;

            switch (highestSeverity) {
                case 0:
                    message = null;
                    break;
                case 1:
                    message = $translate.instant('NOT_IN_MY_SUPPLY_CHAIN_MULTIPLE_WARNING');
                    break;
                case 2:
                    message = $translate.instant('VANTIFY_SUPPLY_CHAIN_MULTIPLE_SP_EXPIRING_WARNING');
                    break;
                case 3:
                case 4:
                    message = $translate.instant('VANTIFY_SUPPLY_CHAIN_MULTIPLE_SP_WARNING');
                    break;
            }

            const color = highestSeverity === 4 ? 'danger' : 'warning';

            return {message, color};
        }
    }

    function filterProsureSpList(selectedServiceProviders) {
        let highestSeverity = getSeverityWarning(selectedServiceProviders);
        selectedServiceProviders = selectedServiceProviders.filter((sp) => {
            switch (highestSeverity) {
                case 1:
                    return sp.meetsProsureRequirements !== 'PROSURE_REQUIREMENTS_SUCCESS'
                case 2:
                    return sp.meetsProsureRequirements !== 'PROSURE_REQUIREMENTS_SUCCESS' &&
                        sp.meetsProsureRequirements !== undefined;
                case 3:
                case 4:
                    return sp.meetsProsureRequirements !== 'PROSURE_REQUIREMENTS_SUCCESS' &&
                        sp.meetsProsureRequirements !== 'PROSURE_REQUIREMENTS_EXPIRING' &&
                        sp.meetsProsureRequirements !== undefined;
            }
        }).map(sp => sp._links?.serviceprovider?.title);

        return selectedServiceProviders;
    }

    function getSeverityWarning(serviceProviders) {
        const severityRank = {
            'PROSURE_SUSPENDED': 4,
            'PROSURE_REQUIREMENTS_BELOW': 3,
            'PROSURE_REQUIREMENTS_EXPIRING': 2,
            'PROSURE_REQUIREMENTS_SUCCESS': 0
        };
        let highestSeverity = 0;

        for (const sp of serviceProviders) {
            const status = sp.meetsProsureRequirements;
            const severity = severityRank[status] !== undefined ? severityRank[status] : 1;

            if (severity > highestSeverity) {
                highestSeverity = severity;
            }

            if (severity === 4) {
                break;
            }
        }

        return highestSeverity;
    }
});
